import React from 'react';
import Pagination, { UsePaginationProps } from '@material-ui/lab/Pagination';

const Paginator = ({ onChange, count, page }: UsePaginationProps) => (
  <Pagination onChange={onChange} color="secondary" page={page} count={count} />
);

export default Paginator;
